<template>
  <sfs-form-modal
    :id="modalId"
    size="md"
    title="Import Work Orders to Cancel"
    @on-hide="resetFormData"
  >
    <imports-form
      destructive-subtitle="This will cancel the selected work orders."

      @on-submit="createCancelWorkOrdersImport"
      @on-save="handleSave"
      @on-cancel="closeModal"
      :key="formKey"
    >
      <template #downloads>
        <b-row>
          <b-col cols="12">
            <sfs-download-button
              label="Download Template"
              filename="Work Orders to Cancel Template.xlsx"
              :file-provider="$importsAPI.getCancelWorkOrdersTemplate"
            />
          </b-col>
        </b-row>
      </template>
    </imports-form>
  </sfs-form-modal>
</template>

<script>
import ImportsForm from './Form.vue';
import formModalMixin from '@/mixins/formModalMixin';

export default {
  name: 'CancelWorkOrdersImportsAddModal',
  mixins: [formModalMixin],
  components: {
    ImportsForm,
  },
  data() {
    return {
      modalId: 'cancel-work-orders-imports-add-modal',
    };
  },
  methods: {
    createCancelWorkOrdersImport(data, handleCreate) {
      handleCreate(this.$importsAPI.cancelWorkOrdersCreate(data));
    },
    handleSave(data) {
      if (this.$route.name != 'imports') {
        this.$router.push({ name: 'imports' });
      } else {
        this.closeModal();
      }
      this.$emit('on-save', data);
    },
  },
};
</script>
